import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import store from './store'
import App from './App'

import * as filters from './filters'

import config from './config'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


  /**
   * 微信H5字体缩放处理
   * 仅在微信H5环境中执行，阻止字体放大影响布局
   * 其他浏览器完全跳过，不会报错
   */
  ; (function () {
    // 先检查基本环境是否存在
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return
    }

    try {
      // 检测是否在微信H5环境
      const ua = navigator.userAgent || ''
      const uaLower = ua.toLowerCase()
      const isWechat = uaLower.indexOf('micromessenger') > -1

      // 只有在微信环境下才执行
      if (!isWechat) {
        return
      }

      // 设置字体大小不被微信调整
      const handleFontSize = function () {
        try {
          // 确保 WeixinJSBridge 存在且可调用
          if (window.WeixinJSBridge && typeof window.WeixinJSBridge.invoke === 'function') {
            window.WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 })
          }
        } catch (e) {
          // 静默处理错误
        }
      }

      // 检查 WeixinJSBridge 是否已就绪
      if (window.WeixinJSBridge && typeof window.WeixinJSBridge.invoke === 'function') {
        handleFontSize()
      } else if (typeof document !== 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
      }
    } catch (e) {
      // 非微信环境或执行出错，静默忽略
    }
  })()











// 判断当前是否是微信浏览器
const boolForWeChatH5 = () => {

  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') !== -1) {
    return true
  }

  return false
}


// 暂时注释：暂无公众号/小程序，微信JSAPI模块不使用
// if (boolForWeChatH5()) {
//   const jweixin = require('./components/jweixin-module')
//   const jwx = require('./components/jweixin-module/jwx')
//   Vue.prototype.$jweixin = jweixin
//   Vue.prototype.$jwx = jwx
//   Vue.mixin({
//     onShow() {
//       // jwx.configWeiXin(jwx => {
//       //   console.log(jwx)
//       // })
//     }
//   })
// }



/**
 * 获取真实的URL
 * 有code的时候要去除微信的code参数
 */
const getRealUrl = (url = window.location.href) => {
  url = url.split('?')
  if (url.length > 1 && url[1].indexOf('code=') !== -1) {
    if (url[1].indexOf('#') !== -1) {
      var temp = url[1].split('#')
      url[0] += '#' + temp[1]
    }
    url.splice(1, 1)
  }
  return url.join('?')
}

const getWechatUserAuth = function (code) {
  const url = getRealUrl();
  const _url = encodeURIComponent(url);
  console.log('_url==', _url)
  if (!code) {
    // code为空，跳转到授权页面
    console.log('appid', config.h5Appid)
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.h5Appid}&redirect_uri=${_url}&response_type=code&scope=snsapi_userinfo&forcePopup=false&forceSnapShot=false&state=STATE#wechat_redirect`
    return;
  }
  return new Promise((resolve, reject) => {
    uni.request({
      url: config.baseUrl + '/common/wechat/getWechatUserAuth',
      data: {
        code: code
      },
      method: 'POST',
      header: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      success: (res) => {
        console.log('res====', res)
        if (res.statusCode === 200) {
          const _data = res.data;
          if (_data.code === 200) {
            resolve(_data)
          } else if (_data.code === 101) {
            // 获取失败，重新发起授权
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.h5Appid}&redirect_uri=${_url}&response_type=code&scope=snsapi_userinfo&forcePopup=false&forceSnapShot=false&state=STATE#wechat_redirect`
            reject(_data)
          } else {
            reject(_data)
          }
        } else {
          reject({ code: res.statusCode, msg: '请求失败' })
        }
      },
      fail: (err) => {
        reject({ code: -1, msg: '网络不可用' })
      }
    })
  })
}


const msg = (title, duration = 1500, mask = false, icon = 'none') => {
  // 统一提示方便全局修改
  if (Boolean(title) === false) {
    return
  }
  uni.showToast({
    title,
    duration,
    mask,
    icon
  })
}

let userInfo

const logout = () => {
  userInfo = undefined
  uni.removeStorage({
    key: 'userInfo'
  })
}

const setUserInfo = (i) => {
  userInfo = i
}

const isVip = () => {
  return userInfo && userInfo.level
}

// 定义不需要登录的接口地址
const notLoginUrlList = ['/captchaImage', '/common/getServiceCode', '/common/config/mall.memberAgreement', '/common/config/mall.privacyAgreement', '/cms/article/category/list', '/cms/article/list', '/cms/article/detail', '/cms/faq/list'];

const request = (url, data = {}, methods = 'GET', failCallback) => {
  // 异步请求数据
  return new Promise((resolve, reject) => {
    if (!userInfo || !userInfo.accessToken) {
      userInfo = uni.getStorageSync('userInfo')
    }
    let _header = { 'Content-Type': 'application/json;charset=UTF-8' };
    const accessToken = userInfo ? userInfo.accessToken : ''
    if (notLoginUrlList.indexOf(url) === -1) {
      _header['Authorization'] = 'Bearer ' + accessToken;
    }
    const baseUrl = config.baseUrl
    uni.request({
      url: baseUrl + url,
      data: {
        ...data,
      },
      method: methods,
      header: _header,
      timeout: 15000,
      success: (res) => {
        if (res.statusCode === 200) {
          if (res.data.code === 200) {
            resolve(res.data)
          } else if (res.data.code === 401) {
            uni.hideLoading()
            if (failCallback) {
              failCallback(res.data)
            } else {
              uni.redirectTo({
                url: '/pages/public/login'
              })
            }
            // reject(res.data)
          } else {
            if (failCallback) {
              failCallback(res.data)
            } else {
              uni.showToast({
                title: res.data.msg,
                icon: 'none'
              })
            }
            // reject(res.data)
          }
        } else {
          reject({ code: res.statusCode, msg: '请求失败' })
        }
      },
      fail: (err) => {
        uni.hideLoading();
        uni.showToast({
          title: '网络不可用，请检查网络连接',
          icon: 'none',
          duration: 2000
        })
        if (failCallback) {
          failCallback({ code: -1, msg: '网络不可用' })
        }
        reject({ code: -1, msg: '网络不可用' })
      }
    })
  })
}

const uploadImg = (url, successCallback) => {
  if (!userInfo || !userInfo.accessToken) {
    userInfo = uni.getStorageSync('userInfo')
  }
  const accessToken = userInfo ? userInfo.accessToken : ''
  const baseUrl = config.baseUrl
  uni.chooseImage({
    sizeType: ['compressed'],
    success: function (res) {
      for (let i = 0; i < res.tempFilePaths.length; i++) {
        uni.showLoading({
          title: '图片上传中'
        })
        const fileName = ('imgs/' + random_string(15) + get_suffix(res.tempFilePaths[i]))
        uni.uploadFile({
          url: baseUrl + url,
          filePath: res.tempFilePaths[i],
          name: 'file',
          formData: {
            url: res.tempFilePaths[i],
            fileName: fileName
          },
          header: {



            'Authorization': 'Bearer ' + accessToken
          },
          success: function (uploadRes) {
            uni.hideLoading()
            console.log(uploadRes)
            if (uploadRes.statusCode === 200) {
              console.log(successCallback)
              if (successCallback) {
                successCallback(JSON.parse(uploadRes.data).data)
              } else {
                uni.showToast({
                  title: '上传成功',
                  icon: 'none'
                })
              }
            } else {
              uni.hideLoading()
              uni.showToast({
                title: '网络错误 code=' + uploadRes.statusCode,
                icon: 'none'
              })
            }
          },
          fail: function (err) {
            uni.hideLoading()
            uni.showToast({
              title: '上传失败，请重试',
              icon: 'none'
            })
          }
        })
      }
    }
  })
}

function get_suffix(filename) {
  const pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos !== -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

function random_string(len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

const prePage = () => {
  const pages = getCurrentPages()
  const prePage = pages[pages.length - 2]
  if (!prePage) {
    return null
  }
  let res = prePage.$vm

  res = prePage

  return res
}

const globalData = {}

export function style(width) {
  if (config.OSS_PROVIDER === 'aliyun') {
    return '?x-oss-process=style/' + width + 'px'
  } else if (config.OSS_PROVIDER === 'qcloud') {
    return '?imageMogr2/thumbnail/' + width + 'x/interlace/0'
  }
}

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  var detail = '[Vue Error] ' + (err && err.message ? err.message : String(err)) + '\nInfo: ' + (info || '')
  if (err && err.stack) detail += '\nStack: ' + err.stack
  console.error(detail)
}
Vue.prototype.$fire = new Vue()
Vue.prototype.$store = store
Vue.prototype.$api = {
  msg,
  prePage,
  request,
  uploadImg,
  logout,
  isVip,
  setUserInfo,
  config,
  globalData,
  style,
  boolForWeChatH5,

  getRealUrl,
  getWechatUserAuth

}

App.mpType = 'app'

const app = new Vue({
  ...App
})
app.$mount()